export const API_URL = import.meta.env.VITE_API_URL;

export const API_ADMIN = import.meta.env.VITE_API_ADMIN;

export const API_WEB = import.meta.env.VITE_API_WEB;

export const STORAGE_LINK = import.meta.env.VITE_STORAGE;


export const schoolLevelIds = {
    secondary: 3,
    preparatory: 2,
    primary: 1,
};


export const translatedSchoolLevels = {
    [schoolLevelIds.secondary]: " الثانوي",
    [schoolLevelIds.preparatory]: "الإعدادي",
    [schoolLevelIds.primary]: "الأبتدائي"
};
export const translatedSchoolLevelsNames = {
    [schoolLevelIds.secondary]: "المرحلة الثانوية",
    [schoolLevelIds.preparatory]: "المرحلة الإعدادية",
    [schoolLevelIds.primary]: "المرحلة الأبتدائية"
};

export const translatedSchoolGrades = {
    1: "الصف الأول",
    2: "الصف الثاني",
    3: "الصف الثالث",
    4: "الصف الرابع",
    5: "الصف الخامس",
    6: "الصف السادس",
};

export const gradeVoucherIds = {
    thirdPreparatory: 9,
    firstSecondary: 10,
    secondSecondary: 11,
    thirdSecondary: 12
};

export const gradesData = [
    {
        id: gradeVoucherIds.thirdPreparatory,
        attributes: {
            grade: 3,
            school_level: schoolLevelIds.preparatory,
            description: "الصف الثالث الإعدادي",
        }
    },
    {
        id: gradeVoucherIds.firstSecondary,
        attributes: {
            grade: 1,
            school_level: schoolLevelIds.secondary,
            description: "الصف الأول الثانوي",
        }
    },
    {
        id: gradeVoucherIds.secondSecondary,
        attributes: {
            grade: 2,
            school_level: schoolLevelIds.secondary,
            description: "الصف الثاني الثانوي",
        }
    },
    {
        id: gradeVoucherIds.thirdSecondary,
        attributes: {
            grade: 3,
            school_level: schoolLevelIds.secondary,
            description: "الصف الثالث الثانوي",
        }
    }
]

